import { WHY_POINTS } from "../../data/content";
import { ChapterHeading } from "./ChapterHeading";
import { Reveal } from "./Reveal";

export const WhyAnimexa = () => (
    <section
        data-testid="why-animexa-section"
        className="py-24 lg:py-32 bg-[#0A0E17]/60 border-y border-white/5"
    >
        <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
            <ChapterHeading
                label="Why Animexa"
                title="Why Businesses Choose Animexa"
                sub="A focused, modern and transparent way of building digital products for growing businesses."
            />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
                {WHY_POINTS.map((p, i) => (
                    <Reveal key={p.title} delay={(i % 2) * 0.08}>
                        <div
                            data-testid={`why-point-${i}`}
                            className="group flex items-start gap-5 rounded-2xl border border-white/8 bg-[#0D131F] p-6 transition-all duration-300 hover:border-[#F5C518]/35 hover:bg-[#131C2E]"
                        >
                            <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-[#F5C518]/20 to-[#F5C518]/5 border border-[#F5C518]/25 flex items-center justify-center shrink-0 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3">
                                <p.icon size={21} className="text-[#F5C518]" />
                            </div>
                            <div>
                                <h3 className="font-display text-lg font-semibold text-white">
                                    {p.title}
                                </h3>
                                <p className="mt-1.5 text-sm text-slate-400 leading-relaxed">
                                    {p.desc}
                                </p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
